import React, { memo } from 'react';
import compose from 'recompose/compose';
import { Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import RemoveFileIcon from './RemoveFileIcon';

const PanelHeading = ({
    text,
    iconClass,
    customClass,
    deleteFile,
    columnGridCount,
}) => (
    <Panel.Heading className={customClass}>
        <div className="row">
            <div className={`col-xs-${columnGridCount - 3} text-left drop-zone-file-name`}>
                <i className={`fa fa-lg ${iconClass}`} />
                {' '}
                {text}
            </div>
            <div className="col-xs-3 text-right">
                <RemoveFileIcon deleteFile={deleteFile} />
            </div>
        </div>
    </Panel.Heading>
);

PanelHeading.defaultProps = {
    customClass: '',
};

PanelHeading.propTypes = {
    text: PropTypes.string.isRequired,
    iconClass: PropTypes.string.isRequired,
    customClass: PropTypes.string,
    deleteFile: PropTypes.func.isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    memo,
)(PanelHeading);
